import { render } from "./OrderConfirmation.vue?vue&type=template&id=78aa0bbf&scoped=true"
import script from "./OrderConfirmation.vue?vue&type=script&lang=js"
export * from "./OrderConfirmation.vue?vue&type=script&lang=js"

import "./OrderConfirmation.vue?vue&type=style&index=0&id=78aa0bbf&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78aa0bbf"]])

export default __exports__